import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';

// Packages
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../../utils/api';

// Components
import Header from '../../../components/Global/Header';
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader';

class ResourceLibrarySingle extends Component {

  state = {
    article: {},
    categories: [],
    archiveInfo: '',
    categoriesLoading: true,
    articleLoading: true
  }

  componentDidMount() {
    const { articleId } = this.props.match.params;
    const { user } = this.props;

    this.setCategories(user)

    API.getResourceLibraryArticle(user, articleId)
    .then(article => this.setState({
      article,
      articleLoading: false
    }))
  }

  setCategories(user) {
    const { category } = this.props.match.params;

    API.getResourceLibraryCategories(user).then(response => {

      let categoryList = response.map((category) => {
        return {name: category.name, link: `/resource-library/${category.wp_id}`, wp_id: category.wp_id}
      })

      let currentCategory = response.filter((thing) => {
        return parseInt(thing.wp_id, 10) === parseInt(category, 10)
      })

      this.setState({
        categories: categoryList,
        archiveInfo: currentCategory[0],
        categoriesLoading: false
      })
    });
  }

  render() {
    const { path, appName } = this.props;
    const {on_trial, trial_active} = this.props.activeProfile.trial_info
    const {
      article,
      categories,
      archiveInfo,
      categoriesLoading,
      articleLoading
    } = this.state;
    function renderPostContent() {
      return {__html: article.body};
    }

    // TODO: Redirect back to dashboard if trial expired?

    return (
      <div className="user-portal resource-library">
        <Helmet>
          <title>{appName} | Resource Library Archive</title>
        </Helmet>
        <Header path={ path }/>
        {
          categoriesLoading
          ? (
            <div className="resource-library-loader-wrap">
              <AppCanvasLoader />
            </div>
          )
          : (
            <section>
              <div className="inner-wrap resource-library-archive resource-library-container">
                <div className="resource-library-archive-overview resource-library-aside">
                  <h4>Resource Library</h4>
                  <h2>{archiveInfo.name}</h2>
                  <p>{archiveInfo.description}</p>

                  <div className="resource-library-archive-overview-categories">
                    <h4>Categories</h4>
                    {
                      categories.map((category) => {
                        return (
                          <Link key={category.wp_id} to={category.link}>
                            {category.name}
                          </Link>
                        )
                      })
                    }
                  </div>
                </div>
                {
                  articleLoading
                  ? (<AppCanvasLoader />)
                  : (
                    on_trial && !trial_active ? (
                      <Redirect to={{ pathname: '/' }} />
                    ) : (
                      <div className="resource-library-single resource-library-content resource-library-single-post">
                        <h5>Posted in: {archiveInfo.name}</h5>
                        <h1>{article.title}</h1>
                        <div className="content" dangerouslySetInnerHTML={renderPostContent()} />

                      </div>
                    )
                  )
                }
              </div>
            </section>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

export default connect(
  mapStateToProps,
  null
)(ResourceLibrarySingle)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/ResourceLibrary/ResourceLibrarySingle.js